// src/systems/collisionSystem.ts — Colisiones Fase 2
import { isWalkable } from '../world/tiles.js';

export function isTileWalkable(map: number[][], x: number, y: number): boolean {
  if (y < 0 || y >= map.length || x < 0 || x >= map[0].length) return false;
  return isWalkable(map[y][x]);
}

export function canMoveTo(map: number[][], x: number, y: number, npcs: {x:number,y:number}[]): boolean {
  if (!isTileWalkable(map, x, y)) return false;
  // NPC bloquea su tile (colisión simple)
  for (const n of npcs) if (n.x===x && n.y===y) return false;
  return true;
}

// Para movimiento fluido: chequea posición float con hitbox pequeña centrada
export function canMoveToFloat(map: number[][], fx: number, fy: number, npcs: {x:number,y:number}[]): boolean {
  const ix = Math.floor(fx + 0.5); // centro del jugador
  const iy = Math.floor(fy + 0.5);
  return canMoveTo(map, ix, iy, npcs);
}
